"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getScrollbarWidth;
exports.hasScrollbar = void 0;

/**
 * https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
 *
 * @returns number
 */
function getScrollbarWidth() {
  var outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth; // force scrollbars

  outer.style.overflow = 'scroll'; // add innerdiv

  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth; // remove divs

  outer.parentNode.removeChild(outer);
  return widthNoScroll - widthWithScroll;
}

var hasScrollbar = function hasScrollbar() {
  return window.innerWidth > document.documentElement.clientWidth;
};

exports.hasScrollbar = hasScrollbar;